/**
 * 任务3：菜单红/灰点映射公共模块——App.vue 侧边栏与 workflow 功能地图共用（一处维护，防止漂移）
 * 后端口径见 TaskCountController（红点 approve/rejected/returnPending；灰点按页面 type 精确）
 */

// 红点：待审批（draft）/ 待修改（rejected）/ 退库管理（draft+pending 5 类型）
export const RED_KEYS = {
  'approve:view': 'approve',
  'rejectedModify:view': 'rejected',
  'return:view': 'returnPending'
}

// 灰点：按页面 type 精确（任务1 灰点精确化 0902 口径——各菜单只显示本类型 pending）
export const GRAY_KEYS = {
  // 入库管理（19）
  'purchase:v2': 'purchaseInboundPending',
  'expressDeliveryNote:v2': 'expressInboundPending',
  // 生产入库申请（/production/pending 同款口径：type=production + sourceType 4 值）
  'productionInbound:view': 'productionApplicationPending',
  'wmsProductionInbound:v2': 'wmsProductionInboundPending',
  // 库存调整入库（type=production + sourceType=NONE）
  'production:v2': 'freeInboundPending',
  // 出库管理（20）
  'wmsProductionOutbound:v2': 'wmsProductionOutboundPending',
  'salesShipment:v2': 'salesShipmentPending',
  'sporadic:view': 'sporadicPending',
  'freeOutbound:v2': 'freeOutboundPending',
  // 库存管理（21）
  'move:v2': 'movePending',
  // 采购送货单生成入口（ERP 模拟 24 下 purchaseDelivery:v2）不挂灰点——创建页无"待收货"语义；
  // 任务4.6：灰点仅属 ERP单据查看入口（137 下 purchaseDelivery:erpViewV2——原 v2 映射误导已移除）
  // ERP 单据（137）——viewV2/erpViewV2 实际 code
  'salesOrder:viewV2': 'salesPartial',
  'purchaseDelivery:erpViewV2': 'purchasePartial',
  'productionOrder:erpViewV2': 'productionActive'
}

/**
 * 任务3：叶子节点计数判定——按菜单 code 匹配红/灰点 key
 * @param {string} code 菜单 code
 * @param {object} counts 计数接口返回 { approve, rejected, returnPending, purchaseInboundPending, ... }
 * @returns {{ count: number, type: string }} type: 'red' | 'gray' | ''（count=0 不渲染）
 */
export function countOfNode(code, counts) {
  const redKey = RED_KEYS[code]
  if (redKey) {
    return { count: counts[redKey] || 0, type: 'red' }
  }
  const grayKey = GRAY_KEYS[code]
  if (grayKey) {
    return { count: counts[grayKey] || 0, type: 'gray' }
  }
  return { count: 0, type: '' }
}
